export const INACTIVITY_MODAL = "Your session is about to expire";
export const INACTIVITY_ACTION = "You will be automatically logged out in:";
export const INACTIVITY_QUESTION = "Would you like to continue your session?";
export const LOGOUT_BUTTON_TEXT = "Log out";
export const CONTINUE_BUTTON_TEXT = "Continue";
